export class Routes {
  // DELETE
  static deleteFile = (fileUuid: string): string => `/api/file/${fileUuid}`

  // POST
  static uploadFile = (): string => "/api/file"
  static cropFile = (): string => "/api/file/crop"
  static restoreFile = (fileUuid: string): string => `/api/file/${fileUuid}/restore`
}
